export { default } from './createGenerateClassName';